import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

// craftsman-ignore: TS002 — matches private-api-client hook convention (default export, e.g. use-shipping-bo-integration-connection-redirect.ts)
export default function useZendeskConnectRedirect(shop: ShopDto) {
  const invalidateShop = useInvalidateShop(shop.id);

  return useApiMutation<
    "post",
    "/shops/{shopId}/integrations/zendesk/oauth-url",
    void
  >("post", "/shops/{shopId}/integrations/zendesk/oauth-url", {
    invalidate: invalidateShop,
    onSuccess: (result) => {
      window.location.href = decodeURIComponent(result);
    },
    mapVariables: () => ({
      params: { path: { shopId: shop.id } },
    }),
  });
}
